import { useMemo } from 'react';

import { useGetAccountAssets } from '~/hooks/apis/offers/useGetAccountAssets';

import { sortAssetsByRecordType } from './accountRelatedModel';

export function useAccountAssets(accountId: string) {
  const { data: roomAssets, isLoading: isLoadingRooms, error: roomsError } = useGetAccountAssets(accountId, 'rooms');
  const {
    data: serviceAssets,
    isLoading: isLoadingServices,
    error: servicesError,
  } = useGetAccountAssets(accountId, 'services');
  const assets = useMemo(
    () => sortAssetsByRecordType([...(roomAssets ?? []), ...(serviceAssets ?? [])]),
    [roomAssets, serviceAssets],
  );

  return { assets, error: roomsError ?? servicesError, isLoading: isLoadingRooms || isLoadingServices };
}
